import React, { useEffect } from 'react';
import { ResponsiveBar } from '@nivo/bar'
import { convertCost } from '../../../Utils/functions';

export const ageMockData = {//age data mockup
    "10": {
        "Total": 0,
        "Add": 1420,
        "Used": 198,
        "AddPoint": 0,
        "UsedPoint": 0
    },
    "20": {
        "Total": 0,
        "Add": 2087,
        "Used": 241,
        "AddPoint": 0,
        "UsedPoint": 0
    },
    "30": {
        "Total": 0,
        "Add": 4058,
        "Used": 351,
        "AddPoint": 0,
        "UsedPoint": 0
    },
    "40": {
        "Total": 0,
        "Add": 3840,
        "Used": 189,
        "AddPoint": 0,
        "UsedPoint": 0
    },
    "50": {
        "Total": 0,
        "Add": 1040,
        "Used": 57,
        "AddPoint": 0,
        "UsedPoint": 0
    },
    "60": {
        "Total": 0,
        "Add": 520,
        "Used": 40,
        "AddPoint": 0,
        "UsedPoint": 0
    }
}

const AgeChart = ({info, type}) => {
    const [ data, setData] = React.useState([])//age data

    //data parsing
    useEffect(() => {
        let newData = []
        let arr = Object.values(info);

        if( type === 'add'){
            for(let i = 1;i <7; i++ ){
                var name = i + '0대';
                if(i === 6){
                    name += ' 이상';
                }
                newData.push({
                    'value' : arr[i-1].Add,
                    "label" : name,
                    'id': name,
                })
            }
        }else {
            for(let i = 1;i <7; i++ ){
                var name = i + '0대';
                if(i === 6){
                    name += ' 이상';
                }
                newData.push({
                    'value' : arr[i-1].Used,
                    "label" : name,
                    'id': name,
                })
            }
        }

        setData(newData)
    },[type])

    useEffect(() => {
        let newData = []
        let arr = Object.values(info);

        if( type === 'add'){
            for(let i = 1;i <7; i++ ){
                var name = i + '0대';
                if(i === 6){
                    name += ' 이상';
                }
                newData.push({
                    'value' : arr[i-1].Add,
                    "label" : name,
                    'id': name,
                })
            }
        }else {
            for(let i = 1;i <7; i++ ){
                var name = i + '0대';
                if(i === 6){
                    name += ' 이상';
                }
                newData.push({
                    'value' : arr[i-1].Used,
                    "label" : name,
                    'id': name,
                })
            }
        }

        setData(newData)
    },[info])

    return (
        <div style={{  height : 280, width : 400 }}>
            <ResponsiveBar
                data={data}
                indexBy="id"
                margin={{ top: 20, bottom: 50, left: 60 }}
                padding={0.7}
                innerPadding={2}
                groupMode="grouped"
                valueScale={{ type: 'linear' }}
                indexScale={{ type: 'band', round: true }}
                colors={[
                    "#d9d9d9",
                    "#f95f53",
                    "#ffc0bb"
                ]}
                tooltip={(props) => {
                    return(
                        <div className='tooltip' style={{ flexDirection : 'column',alignItems : 'center', justifyContent : 'center',display : 'flex',backgroundColor : 'white', padding : 16, paddingTop : 16, paddingBottom : 1, borderRadius : 24, boxShadow : '0 12px 14px 0 rgba(0, 0, 0, 0.07)' }}>
                            {
                                Object.keys(props).length > 0 &&
                                <>
                                    <p style={{ fontSize : 12, fontWeight : 500, lineHeight : 1.5, color : '#3f3f3f'}}>{props.indexValue}</p>
                                    <p style={{ fontSize : 18, fontWeight : 'bold', lineHeight : 1.78, textAlign : 'center', color : '#f95f53'}}>{convertCost(props.value)} 건</p>
                                </>
                            }
                        </div>
                    )
                  }}
                borderRadius={4}
                borderColor={{
                    from: 'color',
                    modifiers: [
                        [
                            'darker',
                            1.6
                        ]
                    ]
                }}
                axisTop={null}
                axisRight={null}
                axisBottom={{
                    tickSize: 5,
                    tickPadding: 5,
                    tickRotation: 0,
                    legend: '',
                    legendPosition: 'middle',
                    legendOffset: 32
                }}
                axisLeft={{
                    tickSize: 5,
                    tickPadding: 24,
                    tickRotation: 0,
                    legend: '',
                    legendPosition: 'middle',
                    legendOffset: -40
                }}
                enableLabel={false}
                labelSkipWidth={12}
                labelSkipHeight={12}
                labelTextColor={{
                    from: 'color',
                    modifiers: [
                        [
                            'darker',
                            1.6
                        ]
                    ]
                }}
                role="application"
            />
        </div>
    )
}

export default AgeChart;